import React from 'react';

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

export interface SegmentedControlProps<T extends string> {
  options: SegmentedOption<T>[];
  value: T | null;
  onChange: (value: T) => void;
  /** aria-label for the radio group when no visible label exists */
  ariaLabel?: string;
}

/**
 * Generic 2/3/4/6-column segmented control. Used for §A stage, §G timeline
 * urgency, §G buyer_type, etc. Active option lifts on a white pill with
 * subtle shadow per the brand pattern.
 */
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
}: SegmentedControlProps<T>) {
  return (
    <div
      className="aa-segmented"
      data-cols={options.length}
      role="radiogroup"
      aria-label={ariaLabel}
    >
      {options.map(opt => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            className={`aa-seg-btn ${active ? 'is-active' : ''}`.trim()}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
